import React, {useEffect, useState} from "react"
import "./UserRegistration.css"
import {DatePickerComponent} from "../ui/DatePickerComponent";

export const BasicInfo = ({userInfo, setUserInfo, page, setPage}) => {

    const [cyrillicErrorFirstName, setCyrillicErrorFirstName] = useState(false)
    const [cyrillicErrorLastName, setCyrillicErrorLastName] = useState(false)
    const [showFirstNameError, setShowFirstNameError] = useState(false)
    const [showLastNameError, setShowLastNameError] = useState(false)
    const [showBirthDateError, setShowBirthDateError] = useState(false)
    const [showPhoneError, setShowPhoneError] = useState(false)
    const [showGenderError, setShowGenderError] = useState(false)

    const [checkedMale, setCheckedMale] = useState(false)
    const [checkedFemale, setCheckedFemale] = useState(false)


    useEffect(() => {
        if(userInfo.gender === null){
            setCheckedMale(false)
            setCheckedFemale(false)
        } else if (userInfo.gender === true){
            setCheckedMale(true)
            setCheckedFemale(false)
        } else if (userInfo.gender === false){
            setCheckedMale(false)
            setCheckedFemale(true)
        }
    },[]);

    const constrictCyrillicValuesFirstName = (e) => {
        const re = /[АБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ абвгдѓежзѕијклљмнњопрстќуфхцчџшш:]+/g;
        if (!re.test(e.key)) {
            setCyrillicErrorFirstName(true)
            setShowFirstNameError(false)
            e.preventDefault();
        } else {
            setCyrillicErrorFirstName(false)
        }
    };

    const constrictCyrillicValuesLastName = (e) => {
        const re = /[АБВГДЃЕЖЗЅИЈКЛЉМНЊОПРСТЌУФХЦЧЏШ абвгдѓежзѕијклљмнњопрстќуфхцчџшш:]+/g;
        if (!re.test(e.key)) {
            setCyrillicErrorLastName(true)
            setShowLastNameError(false)
            e.preventDefault();
        } else {
            setCyrillicErrorLastName(false)
        }
    };


    const subtractFromDate = (
        date,
        { years, days, hours, minutes, seconds, milliseconds } = {}
    ) => {
        const millisecondsOffset = milliseconds ?? 0
        const secondsOffset = seconds ? 1000 * seconds : 0
        const minutesOffset = minutes ? 1000 * 60 * minutes : 0
        const hoursOffset = hours ? 1000 * 60 * 60 * hours : 0
        const daysOffset = days ? 1000 * 60 * 60 * 24 * days : 0
        const dateOffset =
            millisecondsOffset +
            secondsOffset +
            minutesOffset +
            hoursOffset +
            daysOffset

        let newDate = date
        if (years) newDate = date.setFullYear(date.getFullYear() - years)
        newDate = new Date(newDate - dateOffset)
        return newDate
    }



    return (
        <div className="basic-info w-100 ">
          <div className="d-flex flex-column w-100">
              <input type="text" placeholder="*Име"
                     onPaste={e => e.preventDefault()}
                     onDrop={e => e.preventDefault()}
                     autoComplete={'false'}
                     onKeyPress={(e) => {
                  constrictCyrillicValuesFirstName(e)
              }}
                     value={userInfo.firstName}
                     onChange={(e) =>{
                         setUserInfo({...userInfo, firstName: e.target.value})
                         setShowFirstNameError(false)
                     }}/>
              {cyrillicErrorFirstName && <small>Ве молиме внесувајте со кирилична поддршка</small>}
              {showFirstNameError && <small>Ве молиме внесете го вашето име со кирилична поддршка</small>}
          </div>

            <div className="d-flex flex-column w-100">
                <input type="text" placeholder="*Презиме"
                       onPaste={e => e.preventDefault()}
                       onDrop={e => e.preventDefault()}
                       autoComplete={'false'}
                       onKeyPress={(e) => {
                    constrictCyrillicValuesLastName(e)
                }}
                       value={userInfo.lastName}
                       onChange={(e) => {
                           setUserInfo({...userInfo, lastName: e.target.value})
                           setShowLastNameError(false)
                       }}
                />
                {cyrillicErrorLastName && <small>Ве молиме внесувајте со кирилична поддршка</small>}
                {showLastNameError && <small>Ве молиме внесете го вашето презиме со кирилична поддршка</small>}
            </div>

                <div className="d-flex flex-column w-100">
                    <DatePickerComponent
                        maxDate={subtractFromDate(new Date(), { years: 14 })}
                        minDate={subtractFromDate(new Date(), { years: 64 })}
                        selectedDate={userInfo.birthDate}
                        onChange={(e)=> {
                            setUserInfo({...userInfo, birthDate:e})
                            setShowBirthDateError(false)
                        }}
                        placeholder="*Датум на раѓање"/>
                    {showBirthDateError && <small>Ве молиме внесете го датумот на раѓање</small>}
                </div>

           <div className="d-flex flex-column w-100">
               <input type="number" placeholder="*Телефон за контакт"
                      value={userInfo.phone}
                      onChange={(e) => {
                          setUserInfo({...userInfo, phone: e.target.value})
                          setShowPhoneError(false)
                      }}
               />
               {showPhoneError && <small>Ве молиме внесете телефон за контакт</small>}
           </div>
               <div className="gender-info">
                   <p>*Пол:</p>
                   <input type="radio" id="male" name="gender" checked={checkedMale}
                          onClick={(e)=> {
                              setUserInfo({...userInfo, gender:true})
                              setShowGenderError(false)
                              setCheckedMale(true)
                              setCheckedFemale(false)
                          }}/>
                   <label htmlFor="male">Машки</label>
                   <input type="radio" id="female" name="gender" checked={checkedFemale}
                          onClick={(e) => {
                          setUserInfo({...userInfo, gender:false})
                              setShowGenderError(false)
                              setCheckedMale(false)
                              setCheckedFemale(true)
                          }}/>
                   <label htmlFor="female">Женски</label>
               </div>
            {showGenderError && <small>Ве молиме одберете пол</small>}
                   <div className='form-footer d-flex justify-content-between'>
                       <button onClick={() => setPage(0)}>Претходна</button>
                       <button onClick={() => {
                           if((userInfo.firstName && userInfo.firstName.split(" ").join("").length >= 2) &&
                               (userInfo.lastName && userInfo.lastName.split(" ").join("").length >= 2) &&
                               (userInfo.birthDate) && (userInfo.phone && userInfo.phone.length >= 7)
                              && (userInfo.gender !== null)){
                               setPage(2)
                           } else if (!userInfo.firstName || userInfo.firstName === "" || userInfo.firstName.split(" ").join("").length <= 1){
                               setShowFirstNameError(true)
                           } else if (!userInfo.lastName || userInfo.lastName === "" || userInfo.lastName.split(" ").join("").length <= 1){
                               setShowLastNameError(true)
                           } else if (!userInfo.birthDate || userInfo.birthDate === ""){
                               setShowBirthDateError(true)
                           } else if (!userInfo.phone || userInfo.phone === "" || userInfo.phone.length <= 6){
                               setShowPhoneError(true)
                           } else if (!checkedFemale && !checkedMale) {
                               setShowGenderError(true)
                           }
                       }}>Следна</button>
                   </div>
        </div>
    )
}